<template>
	<div class="wrapper">
		<div v-show="!hideDot" :class="[color]" class="dot solid"/>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'TDot',
	props: {
		/**
		 * Can be any color from colors/_palette.scss.
		 */
		color: {
			type: String,
			default: 'neutral'
		},
		hideDot: {
			type: Boolean,
			default: false,
		}
	}
};
</script>

<style lang="scss" scoped>
@import './badgeMixin';

.wrapper {
	display: flex;
	position: relative;
}

.dot {
	@include colors();
	position: absolute;
	top:0;
	right:-1px;
	display: inline-block;
	height: 7px;
	width: 7px;
	border-radius: 1000px;
}
</style>


<docs>
## Examples

```jsx noeditor
<div style="display: inline-grid; grid-column-gap: 10px; grid-row-gap: 10px; grid-template-columns: repeat(8, auto);">
	<t-dot color="yellow">
		<t-timpex-icon type="bp" size="sm" icon="filter"></t-timpex-icon>
	</t-dot>
</div>
```
#### Example Code
```html
	<t-dot color="yellow">
		<t-timpex-icon type="bp" size="sm" icon="filter"></t-timpex-icon>
	</t-dot>
```
</docs>
